import React from 'react';
import { OpenLogin, OpenSignup } from '../../SignupLogin';
import { Container, Row, Col, Button } from 'reactstrap';
import { T } from '../../../traks';
import { site_name } from '../../../Site';

export const NotLoggedIn = () => {
  return (
    <div className="checkout-login-page">
      <Container className="checkout-login-container">
        <Row className="justify-content-center">
          <Col xs="12" md="10" lg="8" className="checkout-login-card">
            <h1 className="checkout-login-title">
              <T>Great that you're about to choose {site_name}!</T>
            </h1>

            <p className="checkout-login-subtitle">
              <T>
                It will be a solid investment in your learning about stocks and strategy.
              </T>
            </p>

            <p className="checkout-login-body">
              <T>
                To complete your purchase, you need to be logged in. Don't have an account yet? No worries – it takes less than 2 minutes, and you can create one right here.
              </T>
            </p>

            <p className="checkout-login-body mb-5">
              <T>It takes under 2 minutes to get started.</T>
            </p>

            <div className="checkout-login-actions">
              <Button
                className="checkout-login-btn checkout-login-btn-login"
                onClick={OpenLogin}
              >
                <T>Login</T>
              </Button>
              <Button
                className="checkout-login-btn checkout-login-btn-signup"
                onClick={OpenSignup}
              >
                <T>Sign up</T>
              </Button>
            </div>

            <div className="checkout-login-help mt-4">
              <T>Need help? Contact us at <a href="mailto:info@aktiedysten.dk">info@aktiedysten.dk</a></T>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/NotLoggedIn.js